import type { SectionsBlocksComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import { Button } from '../../atoms'

import * as styles from './blocks.styles'
import { FeatureCard } from './card'

const CARD_LIMIT = 4

export function Blocks({
  title,
  titleHighlighedPart,
  description,
  descriptionHighlightedPart,
  cta,
  ctaSecondary,
  featureCard,
}: SectionsBlocksComponent) {
  const {
    before: titleBefore,
    highlight: titleHighLighted,
    after: titleAfter,
  } = useHighlightedText(title, titleHighlighedPart)

  const {
    before: descBefore,
    highlight: descHighLighted,
    after: descAfter,
  } = useHighlightedText(description, descriptionHighlightedPart)

  const cards = featureCard?.slice(0, CARD_LIMIT)

  return (
    <div css={styles.wrapper}>
      <div css={styles.text}>
        <h2 css={styles.title}>
          {titleBefore}
          <span>{titleHighLighted}</span>
          {titleAfter}
        </h2>

        <div css={styles.blocksMobile}>
          {cards?.map((card) => <FeatureCard key={card.id} card={card} />)}
        </div>

        <div css={styles.description}>
          {descBefore}
          <span>{descHighLighted}</span>
          {descAfter}
        </div>

        <div css={styles.buttons}>
          {cta && <Button {...cta[0]} />}
          {ctaSecondary && <Button {...ctaSecondary[0]} variant="inverted" />}
        </div>
      </div>

      <div css={styles.blocksDesktop}>
        {cards?.map((card) => <FeatureCard key={card.id} card={card} />)}
      </div>
    </div>
  )
}
